import { map } from 'rxjs/operators';
import { Component, EventEmitter, Output, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { LocalStorageService } from 'angular-2-local-storage';
import { CreateImageTipModel, ImageTipItemModel } from '../../../../../model/builk/image-tip/image-tip.model';
import { ImageTipService } from '../../../../../service/api/builk/image-tip.service';

@Component({
  selector: 'app-create-image-tip',
  templateUrl: './create-image-tip.component.html',
  styleUrls: ['./create-image-tip.component.scss']
})
export class CreateImageTipComponent {
  @ViewChild("template") template: TemplateRef<any>;
  @ViewChild("templateEdit") templateEdit: TemplateRef<any>;

  modalRef: BsModalRef;

  @Output() isSaved = new EventEmitter();
  @Output() okEvent = new EventEmitter();

  // model
  createModel: CreateImageTipModel = new CreateImageTipModel();
  updateModel: CreateImageTipModel = new CreateImageTipModel();
  tempModel: ImageTipItemModel = new ImageTipItemModel();
  invalid = {
    title: false,
    linkUrl: false,
    file: false,
  }

  // boolean
  isCreating: boolean = false;

  // number

  // string

  // file
  files: FileList;
  imageSrc;

  constructor(
    private modalService: BsModalService,
    private imageTipService: ImageTipService,
    private localStorageService: LocalStorageService
  ) { }

  openModal(): void {
    this.createModel = new CreateImageTipModel();
    this.modalRef = this.modalService.show(this.template, {
      class: "modal-lg"
    });
  }

  edit(value: ImageTipItemModel): void {
    // this.editModel = {
    // }
    this.tempModel = value;

    this.modalRef = this.modalService.show(this.templateEdit, {
      class: "modal-lg"
    });
  }

  close(): void {
    this.modalRef.hide();
  }

  save(): void {
    if (this.validateImageTip() == false) {
      return;
    }
    this.isCreating = true;
    // this.couponModel.couponStartDate = this.periodDate[0].toISOString();
    // this.couponModel.couponEndDate = this.periodDate[1].toISOString();
    // this.couponModel.couponDiscountValue = Number(this.couponModel.couponDiscountValue);
    // this.couponModel.couponMinimumDiscount = Number(this.couponModel.couponMinimumDiscount);
    // this.couponModel.couponMaximumDiscount = Number(this.couponModel.couponMaximumDiscount);
    // this.couponModel.couponQuotaLimit = Number(this.couponModel.couponQuotaLimit);
    // this.couponModel.couponCompanyQuotaLimit = Number(this.couponModel.couponCompanyQuotaLimit);
    this.createModel.userSurrKey = this.localStorageService.get("userSurrKey");

    let preData: CreateImageTipModel = {
      file: this.files[0],
      linkUrl: this.createModel.linkUrl,
      userSurrKey: this.createModel.userSurrKey,
      title: this.createModel.title,
      projImgtipSurrKey: 0, 
    }
    // save
    this.imageTipService.createImageTip(preData).subscribe(res => {
      if (res) {
        this.isSaved.emit(true);
        this.close();
      }
      this.isCreating = false;
    }, err => {
      console.log(err.message);
      this.isCreating = false;
    }, () => {
      this.isCreating = false;
    });
  }

  // updateCoupon() {
  //   this.couponService.updateCoupon([this.editCouponModel]).subscribe(res => {
  //     if (res) {
  //       this.isSaved.emit(true);
  //       this.close();
  //     }
  //   });
  // }

  validateImageTip() {
    var isvalid: Array<boolean> = [];
    const checkNullOrEmthy = (val: string) => (val != null && val != '' && val != undefined && val.length > 0);

    if (checkNullOrEmthy(this.createModel.title)) {
      this.invalid.title = false
    } else {
      this.invalid.title = true
    }
    isvalid.push(this.invalid.file);
    isvalid.push(this.invalid.linkUrl);
    isvalid.push(this.invalid.title);
    return isvalid.every(val => val == false);
  }

  getImage() {
    if(this.files.length > 0) {
      const file = this.files[0];
      const reader = new FileReader();
      reader.onload = e => this.imageSrc = reader.result;
      reader.readAsDataURL(file);
    }
  }
  uploadFile(event: Event) {
    const element = event.currentTarget as HTMLInputElement;
    let fileList: FileList | null = element.files;
    if (fileList) {
      this.files = fileList;
      this.getImage();
    }
  }
}
